module.exports = __webpack_public_path__ + "assets/img/exide-logo-black.9a9585b0.svg";